export enum ERROR_ACTION_TYPES {
    SET_IS_ERROR = 'error/SET_IS_ERROR',
}